import { render, staticRenderFns } from "./DataAnalytics.vue?vue&type=template&id=5745eb86&scoped=true&"
import script from "./DataAnalytics.vue?vue&type=script&lang=js&"
export * from "./DataAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5745eb86",
  null
  
)

export default component.exports